import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";

export function deleteEvent(_event_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // 🟢 Delete the specific event using its id string
            return dataStore.delete(_event_id).then(() => {
                console.log(
                    `Event with ID ${_event_id} deleted successfully from browser database.`
                );
                return true;
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEvent:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}